import { useMutation } from "@tanstack/react-query";
import { customAxios } from "lib/axios";
import { showNotification } from "@mantine/notifications";
import { AxiosError } from "axios";

interface ChangePinResponse {
  success: boolean;
  message: string;
  loginPin?: string;
}

export const useChangeUserPin = () =>
  useMutation<
    ChangePinResponse,
    AxiosError<{ message?: string }>,
    { userId: string; newPin?: string }
  >({
    mutationFn: async ({ userId }) => {
      const response = await customAxios.post<ChangePinResponse>(
        `/users/${userId}/change-pin`,
        {}
      );
      return response.data;
    },
    onSuccess: (data) => {
      showNotification({
        title: "Success",
        message: data.message || "PIN regenerated successfully",
        color: "green",
      });
    },
    onError: (error: AxiosError<{ message?: string }>) => {
      const errorMsg = error?.response?.data?.message || "Failed to regenerate PIN";
      showNotification({
        title: "Error",
        message: errorMsg,
        color: "red",
      });
    },
  });
